import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount, currency = 'TRY') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2
  }).format(amount)
}

export function formatCrypto(amount, symbol = 'USDC') {
  return `${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 })} ${symbol}`
}

export function formatDate(date) {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(new Date(date))
}

export function formatShortDate(date) {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }).format(new Date(date))
}

export function shortenAddress(address, chars = 4) {
  if (!address) return ''
  return `${address.slice(0, chars + 2)}...${address.slice(-chars)}`
}

export function getExpenseCategoryLabel(category) {
  const labels = {
    electricity: 'Electricity',
    water: 'Water',
    internet: 'Internet',
    dues: 'Dues',
    rent: 'Rent',
    school: 'School',
    course: 'Course',
    subscription: 'Subscription',
    salary: 'Salary',
    other: 'Other'
  }
  return labels[category] || category
}

export function getIncomeCategoryLabel(category) {
  const labels = {
    sales: 'Sales',
    service: 'Service',
    investment: 'Investment',
    rental: 'Rental Income',
    other: 'Other'
  }
  return labels[category] || category
}

export function getExpenseCategoryIcon(category) {
  const icons = {
    electricity: 'Zap',
    water: 'Droplets',
    internet: 'Wifi',
    dues: 'Building2',
    rent: 'Home',
    school: 'GraduationCap',
    course: 'BookOpen',
    subscription: 'CreditCard',
    salary: 'Users',
    other: 'MoreHorizontal'
  }
  return icons[category] || 'Circle'
}
